// Utility to get API URL with trailing slash removed
export const getApiUrl = (): string => {
  const url = (import.meta.env.VITE_API_URL as string) || 'https://ltp1ccays5.execute-api.us-east-1.amazonaws.com/prod';
  return url.replace(/\/$/, '');
};

// Utility to get Admin API URL for campaign/admin endpoints
export const getAdminApiUrl = (): string => {
  const url = (import.meta.env.VITE_ADMIN_API_URL as string) || 'https://o6rfcb60oe.execute-api.us-east-1.amazonaws.com/prod';
  return url.replace(/\/$/, '');
};
